import Module from "@/modules/services/Module";
import ServicePage from "@/modules/services/views/ServicePage";

export default {
    path: "/service",
    component: Module,
    children: [
        {
            path: 'news',
            component: ServicePage,
            meta: {
                title: 'Новости'
            },
            props: {
                url: process.env.VUE_APP_NEWS_UI_URL
            }
        },
        {
            path: 'settings',
            component: ServicePage,
            meta: {
                title: 'Настройки'
            },
            props: {
                url: process.env.VUE_APP_SETTINGS_UI_URL
            }
        },
        {
            path: 'ratings',
            component: ServicePage,
            meta: {
                title: 'Оценки покупок'
            },
            props: {
                url: process.env.VUE_APP_RATING_UI_URL
            }
        },
        {
            path: 'shop-orders',
            component: ServicePage,
            meta: {
                title: 'Заказы',
            },
            props: {
                url: process.env.VUE_APP_SHOP_ORDER_UI_URL
            }
        },
        {
            path: 'promotions',
            component: ServicePage,
            meta: {
                title: 'Акции',
            },
            props: {
                url: process.env.VUE_APP_PROMOTIONS_UI_URL
            }
        },
        {
            path: 'synonyms',
            component: ServicePage,
            meta: {
                title: 'Синонимы',
            },
            props: {
                url: process.env.VUE_APP_ES_SYNONYMS_UI_URL
            }
        },
    ]
};
